// extracted by mini-css-extract-plugin
export default {"button":"Button_button__OuOnx","whatsappBtn":"Button_whatsappBtn__uxftv","btnDisable":"Button_btnDisable__OCuFI"};